import React, { useEffect, useState, useMemo } from "react";
import "./Home.css";
import Card from "../../Components/Card/Card";
import { productsService } from "../../Modules/Services/products.service.ts";
import API_BASE_URL from "../../config";
import SEO from "../../Components/SEO/SEO.jsx";

const Home = () => {
  const [rawCategories, setRawCategories] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState("all");

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const data = await productsService.getProducts();
        setRawCategories(data);
      } catch (error) {
        console.error("Ошибка при получении товаров:", error);
      }
    };

    fetchProducts();
  }, []);

  const categories = useMemo(() => {
    if (!rawCategories.length) return [];

    const allProducts = rawCategories.flatMap((category) => category.products);
    const allCategory = {
      category_id: "all",
      category_name: "Всё",
      products: allProducts,
    };
    return [allCategory, ...rawCategories];
  }, [rawCategories]);

  const selectedCategory = categories.find(
    (c) => c.category_id === selectedCategoryId
  );

  return (
    <div className="Home--Container">
      <SEO
        title="Меню кафе Шахризада"
        description="Полное меню нашего кафе: шаурма, арабский кофе, восточные сладости"
        keywords="меню, цены, шаурма, кофе, десерты"
      />
      <nav className="Home--CategorySidebar">
        <ul>
          {categories.map((category) => (
            <li
              key={category.category_id}
              className={
                category.category_id === selectedCategoryId ? "active" : ""
              }
              onClick={() => setSelectedCategoryId(category.category_id)}
            >
              {category.category_name}
            </li>
          ))}
        </ul>
      </nav>
      <main className="Home--ProductsGrid">
        {selectedCategory && (
          <section id={selectedCategory.category_id} className="Menu--Section">
            <h2>{selectedCategory.category_name}</h2>
            <div className="Menu--Grid">
              {selectedCategory.products.map((product) => (
                <Card
                  key={product.product_id}
                  product={product}
                  title={product.product_name}
                  description={product.composition}
                  variants={product.variants}
                  image={`${API_BASE_URL}${product.image_url}`}
                />
              ))}
            </div>
          </section>
        )}
      </main>
    </div>
  );
};

export default Home;
